/** Reasons a server-side redirect may select, so a crafted query cannot pick the message. */
export const REDIRECT_REASONS = ['email_link'];

/** The route our redirects target; a reason is only honoured here. */
export const REDIRECT_ROUTE = '/content_unavailable';

/**
 * The message the error view should render: a reason supplied by one of our own redirects,
 * otherwise the code it was given.
 *
 * `routing.query` is attacker-controlled and the error view also serves generic 404s and
 * 503s, so a reason counts only on the route those redirects target and only when it names
 * a case we actually redirect for. Without both checks, any failing URL could be given
 * `?reason=email_link` and shown an unrelated message.
 *
 * Matched on `path` before `pathname` because the two renders carry different state: the
 * server stores the matchPath result, which has `path` and no `pathname`, while the client
 * spreads location in as well. Reading only `pathname` renders the generic message during
 * SSR and then hydrates to a different one.
 */
export function errorCode(routing, code) {
  const reason = routing?.query?.reason;
  const route = routing?.path ?? routing?.pathname;
  const fromRedirect =
    route === REDIRECT_ROUTE && REDIRECT_REASONS.includes(reason);
  return fromRedirect ? reason : code;
}
